import React from 'react';
import PlannerFrame from './PlannerFrame';

const AriaPlanner = () => {
  return (
    <PlannerFrame
      title="ARIA Planner"
      src="/aria-app.html"
      topPaddingExtra={16}
    />
  );
};

export default AriaPlanner;

